module.exports = __webpack_public_path__ + "1f25e8eb0ab3a47fcebd20952cdd4b3f.svg";